import { Injectable } from '@angular/core';
import { IQuotationBlock } from "libraries/service/resources/quotation-quotations/IQuotationsQuotation";

@Injectable()
export class QuotationPriceToolsService {
    public hasTotalPrice(block: IQuotationBlock): boolean {
        return Boolean(block.totalPrices && block.totalPrices.length > 0);
    }

    public hasCostValue(block: IQuotationBlock): boolean {
        return Boolean(block.cost && block.cost.value);
    }
}